namespace Ir.Components.Workbook.ToolBarTab {
    interface IToolBarTabViewModel {
        tabPanelConfig: any,
    }

    let drilldownTabIndex = 0;
    let analyzeByTabIndex = 0;
    let dashboardWidgetsTabIndex = 0;   
    export function getViewModel(this: IToolBarTabViewModel, params: any) {
        let config = params.config as WorkbookConfig;

        let tabsDataSource = getDataSource(config);

        drilldownTabIndex = tabsDataSource.findIndex(x => x.isDrilldownTab);
        analyzeByTabIndex = tabsDataSource.findIndex(x => x.isAnalyzeByTab);
        dashboardWidgetsTabIndex = tabsDataSource.findIndex(x => x.isDashboardWidgetsTab);

        goToAnalyzeByTab();

        this.tabPanelConfig = {
            dataSource: tabsDataSource,
            selectedIndex: config.workbookHelper.activeToolbarTab,
            width: '100%',
            height: 71,
            animationEnabled: false,
            swipeEnabled: true,
            tabsPosition: ko.observable("top"),
            stylingMode: "secondary",
            iconPosition: "left",
            repaintChangesOnly: true,
            itemTitleTemplate: titleTemplate,
            onSelectionChanged(e) {
                IntroService.refreshIntroHints();
            },
        };
    }

    export function goToDrilldownTab() {
        workbook.workbookConfig.workbookHelper.activeToolbarTab(drilldownTabIndex);
    }

    export function goToAnalyzeByTab() {
        let activeTab = workbook.workbookConfig.activeTab();
        if (workbook.workbookConfig.generalSettings.editing() && activeTab.tabType() === TabTypeEnum.Dashboard && activeTab.dashboard.widgets().length == 0) {
            workbook.workbookConfig.workbookHelper.activeToolbarTab(dashboardWidgetsTabIndex);
            IntroService.callIntroForEmptyDashboard();
        }
        else {
            workbook.workbookConfig.workbookHelper.activeToolbarTab(analyzeByTabIndex);
        }
    }

    function getToolbarSeparator() {
        return {
            locateInMenu: 'auto',
            location: 'before',
            template(itemData, itemIndex, element) {
                $('<div>')
                    .addClass('toolbar-separator')
                    .appendTo(element);
            },
            menuItemTemplate(itemData, itemIndex, element) {
                $('<div>')
                    .addClass('toolbar-menu-separator')
                    .appendTo(element);
            }
        }
    }

    function onButtonClick(name) {
        DevExpress.ui.notify(`The "${name}" button has been clicked`);
    }

    function generateToolbar(divId, toolbarItems, onInitialized = null) {
        let $div = $(`<div id='${divId}' data-bind='dxToolbar: toolBarConfig'>`);
        ko.applyBindings({
            toolBarConfig: {
                dataSource: toolbarItems,
                onInitialized(e) {
                    onInitialized?.(e);
                }
            } as DevExpress.ui.dxToolbar.Properties
        }, $div[0]);
        return $div;
    }

    function titleTemplate(itemData, itemIndex, itemElement) {
        let $icon = $('<i data-bind="html: $data">');

        if (itemData.iconClass) {
            $icon.addClass(itemData.iconClass);
        }
        else {
            $icon.addClass("ms");
        }

        ko.applyBindings(itemData.icon, $icon[0]);
        itemElement.append($icon);

        let $span = $(`<span data-bind="text: $data"></span>`);
        ko.applyBindings(itemData.title, $span[0]);
        itemElement.append($span);

        if (itemData.templateClass) {
            itemElement.addClass(itemData.templateClass);
        }
    }

    function getDataSource(config: WorkbookConfig) {
        let generalSettings = config.generalSettings;
        let dxWorkbookToolbarComponent: DevExpress.ui.dxToolbar;
        let locateInMenuAlwaysMobile = isMobile() ? "always" : "auto";

        let isNewWorkbook = ko.computed(function () { return workbook.workbookConfig.workbookId() < 0; });
        return [
            {
                icon: 'home',
                iconClass: 'ms',
                title: 'Home',
                visible: false, //loggedUser.permissions.createWorkbooks() ||
                //        loggedUser.permissions.workbooks() ||
                //        loggedUser.permissions.editFormattingRules() ||
                //        loggedUser.permissions.formattingRules() ||
                //        loggedUser.permissions.editPDFTemplates() ||
                //        loggedUser.permissions.pdfTemplates() ||
                //        loggedUser.enableAdmin() || 
                //        loggedUser.permissions.emailsManagement(),
                template: () => {
                    return generateToolbar("tabworkbooktoolsettings", [
                        {
                            location: 'before',
                            template: "<create-workbook-toolbar></create-workbook-toolbar>",
                            locateInMenu: locateInMenuAlwaysMobile,
                        },
                        { ...getToolbarSeparator(), visible: loggedUser.permissions.createWorkbooks() },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            options: {
                                hint: 'Home Page',
                                template: `<i class="ms">home</i> Workbooks`,
                                onClick(e) {
                                    workbook.workbookConfig.workbookHelper.goToURL("/home/home", "Home Page");
                                }
                            },
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            options: {
                                hint: 'Admin',
                                template: `<i class="ms">admin_panel_settings</i> Admin`,
                                onClick(e) {
                                    workbook.workbookConfig.workbookHelper.goToURL("/admin", "Administration Page");
                                }
                            },
                            visible: ko.computed(function () {
                                return loggedUser.enableAdmin();
                            })
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            template: "<formattingrules-toolbar></formattingrules-toolbar>"
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            template: "<pdftemplate-toolbar></pdftemplate-toolbar>"
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            options: {
                                hint: 'Emails Management',
                                template: `<i class="ms">inbox_customize</i> Emails Management`,
                                onClick(e) {
                                    Ir.Components.Email.ScheduledEmailEditor.show(true);
                                }
                            },
                            visible: ko.computed(function () {
                                return loggedUser.permissions.emailsManagement();
                            })
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            template: "<emaillogs-toolbar></emaillogs-toolbar>"
                        },
                        {
                            location: 'after',
                            widget: 'dxButton',
                            options: {
                                hint: 'Workbook Tabs Position',
                                template: () => {
                                    let $element = $(`<div><i class="ms" data-bind="text: icon">sync</i><span data-bind="text: name">/span></div>)`);

                                    ko.applyBindings({
                                        name: ko.computed(function () {
                                            if (generalSettings.workbookTabsPosition() === "bottom") {
                                                return "Bottom";
                                            }
                                            else {
                                                return "Top";
                                            }
                                        }),
                                        icon: ko.computed(function () {
                                            if (generalSettings.workbookTabsPosition() === "bottom") {
                                                return "position_bottom_left";
                                            }
                                            else {
                                                return "subheader";
                                            }
                                        }),
                                    }, $element[0]);
                                    return $element;
                                },
                                onClick(e) {
                                    if (generalSettings.workbookTabsPosition() === "bottom") {
                                        generalSettings.workbookTabsPosition("top");
                                    }
                                    else {
                                        generalSettings.workbookTabsPosition("bottom");
                                    }
                                    onButtonClick(e.component.option("hint"));
                                },
                            },
                            visible: true
                        }
                    ]);
                },
            },
            {
                icon: 'import_contacts',
                title: 'Workbook',
                template: () => {
                    return generateToolbar("tabworkbooktoolbar", [
                        {
                            location: 'before',
                            widget: 'dxSwitch',
                            locateInMenu: "auto",
                            options: {
                                value: generalSettings.editing as any,
                                elementAttr: {
                                    class: "switch30 edit-view-mode",
                                },
                                height: 30,
                                switchedOffText: "View Mode",
                                switchedOnText: "Edit Mode",
                                width: 94,
                                onValueChanged(e) {
                                    workbook.workbookConfig.generalSettings.onEditingChanged();

                                    //Repaint so the button position works
                                    if (isMobile()) {
                                        if (dxWorkbookToolbarComponent && (dxWorkbookToolbarComponent as any).isReady()) {
                                            (dxWorkbookToolbarComponent as any)._render();
                                        }
                                    }
                                },
                            } as DevExpress.ui.dxSwitch.Properties,
                            disabled: ko.computed(function () {
                                return !(loggedUser.permissions.workbooks() || (workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.ViewOnly && workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted));
                            }),
                            visible: loggedUser.permissions.workbooks() || (workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.ViewOnly && workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted)
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            locateInMenu: "auto",
                            options: {
                                hint: 'Save changes to Workbook',
                                template: `<i class="ms">save</i> <span>Save</span>`,
                                onClick(e) {
                                    workbook.workbookConfig.workbookHelper.save();
                                },
                            },
                            disabled: ko.computed(function () { return !workbook.workbookConfig.generalSettings.editing() }),
                            visible: loggedUser.permissions.workbooks() || workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            locateInMenu: "auto",
                            options: {
                                hint: 'Create a copy of Workbook',
                                template: `<i class="ms">save_as</i> <span>Save As</span>`,
                                onClick(e) {
                                    workbook.workbookConfig.workbookHelper.showCopyWorkbook();
                                },
                            },
                            disabled: ko.computed(function () {
                                return isNewWorkbook() || !loggedUser.permissions.createWorkbooks();
                            }),
                            visible: loggedUser.permissions.workbooks() || workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            locateInMenu: "auto",
                            options: {
                                hint: ko.computed(function () {
                                    return workbook.workbookConfig.defaultWorkbook() ? 'Unset as default workbook' : 'Set as default workbook';
                                }),
                                template: ko.computed(function () {
                                    return `<i class="ms" style="${workbook.workbookConfig.defaultWorkbook() ? "color: #ffc107;" : ""}">star</i> Default`;
                                }),
                                onClick(e) {
                                    workbook.workbookConfig.workbookHelper.setDefaultWorkbook();
                                },
                            },
                            disabled: isNewWorkbook
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            locateInMenu: "auto",
                            options: {
                                hint: 'Undo Changes',
                                template: `<i class="ms">undo</i> Undo`,
                                onClick(e) {
                                    document.location = `${urlConfigs.tabs}UndoChanges/${workbook.workbookConfig.workbookId()}`;
                                },
                            },
                            disabled: isNewWorkbook
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            locateInMenu: locateInMenuAlwaysMobile,
                            options: {
                                hint: 'Scheduled Emails',
                                template: `<i class="ms">mail</i> <span>Scheduled Emails</span>`,
                                onClick(e) {
                                    Ir.Components.Email.ScheduledEmailEditor.show(false);
                                },
                            },
                            disabled: ko.computed(function () {
                                return isNewWorkbook() || !loggedUser.permissions.scheduleEmails();
                            }),
                            visible: !isMobile() && (loggedUser.permissions.workbooks() || workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted)
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            locateInMenu: "auto",
                            options: {
                                hint: 'Share the Workbook',
                                template: `<i class="ms">share</i> Share`,
                                onClick(e) {
                                    workbook.workbookConfig.workbookHelper.showShareWorkbook(workbook.workbookConfig.workbookId());
                                },
                            },
                            disabled: isNewWorkbook,
                            visible: ko.computed(function () {
                                return loggedUser.permissions.shareWorkbooks() &&
                                    (loggedUser.permissions.workbooks() || workbook.workbookConfig.userEditMode === WorkbookEditModeEnum.Owner || workbook.workbookConfig.userEditMode === WorkbookEditModeEnum.EditBySharedUser);
                            })
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            locateInMenu: "auto",
                            options: {
                                hint: 'Preferences',
                                template: `<i class="ms">tune</i> Preferences`,
                                onClick(e) {
                                    Ir.Components.Workbook.WorkbookPreferencesPopover.show(e.element);
                                }                                
                            },
                            visible: workbook.workbookConfig.generalSettings.editing as any
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            locateInMenu: "auto",
                            options: {
                                hint: 'Workbook Information',
                                template: `<i class="ms">info</i> Info`,
                                onClick(e) {
                                    workbook.workbookConfig.workbookHelper.showWorkbookInfo();
                                },
                            },
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            locateInMenu: "auto",
                            options: {
                                hint: 'Delete Workbook',
                                template: `<i class="ms">close</i> Del`,
                                stylingMode: 'contained',
                                onClick(e) {
                                    workbook.workbookConfig.delete();
                                },
                            },
                            visible: ko.computed(function () {
                                return workbook.workbookConfig.generalSettings.editing() && workbook.workbookConfig.workbookId() > 0 && (loggedUser.permissions.workbooks() || workbook.workbookConfig.userEditMode === WorkbookEditModeEnum.Owner);
                            })
                        },
                        { ...getToolbarSeparator(), visible: workbook.workbookConfig.generalSettings.editing as any },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            template: "<create-report-toolbar></create-report-toolbar>",
                            locateInMenu: "auto",
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            template: "<create-dashboard-toolbar></create-dashboard-toolbar>",
                            locateInMenu: "auto",
                        },
                        {
                            location: 'before',
                            widget: 'dxButton',
                            template: "<copy-tab-another-workbook></copy-tab-another-workbook>",
                            locateInMenu: "auto",
                        },
                        {
                            location: 'after',
                            locateInMenu: "auto",
                            widget: 'dxDropDownButton',
                            options: {
                                width: 90,
                                displayExpr: "title",
                                items: [
                                    {
                                        icon: 'picture_as_pdf',
                                        name: 'PDFLandscape',
                                        title: 'Landscape',
                                        tooltip: 'PDF Landscape'
                                    },
                                    {
                                        icon: 'picture_as_pdf',
                                        name: 'PDFTemplate',
                                        title: 'Template',
                                        tooltip: 'PDF Template',
                                    }
                                ],
                                splitButton: true,
                                hint: 'PDF Portrait',
                                text: 'PDF',
                                icon: 'ms-icon',
                                stylingMode: isMobile() ? "underlined" : "outlined",
                                onButtonClick(e) {
                                    workbook.workbookConfig.exportToPDF(false, null);
                                },
                                onItemClick(e) {
                                    switch (e.itemData.name) {
                                        case "PDFLandscape":
                                            workbook.workbookConfig.exportToPDF(true, null);
                                            break;
                                        case "PDFTemplate":
                                            workbook.workbookConfig.workbookHelper.showPDFTemplate((pdfTemplateId, landscape) => {
                                                workbook.workbookConfig.exportToPDF(landscape, pdfTemplateId);
                                            });
                                            break;
                                        default:
                                    }
                                },
                                itemTemplate(itemData) {
                                    let $div = $('<div>').css("height", 26).css("padding-top", 3)
                                    $div.append($('<i>')
                                        .text(itemData.icon)
                                        .addClass('ms'));
                                    $div.append($('<span>')
                                        .text(itemData.title).attr("title", itemData.tooltip));
                                    return $div;
                                },
                                onContentReady(e) {
                                    $(".dx-icon-ms-icon", e.element).append("picture_as_pdf").addClass("ms").removeClass("dx-icon-ms-icon dx-icon");
                                }
                            },
                            visible: loggedUser.permissions.printExportPDF()
                        },
                        {
                            location: 'after',
                            locateInMenu: "auto",
                            widget: 'dxButton',
                            template: `<send-emailnow-button></send-emailnow-button>`,
                            visible: loggedUser.permissions.sendEmail() && (loggedUser.permissions.printExportPDF() || loggedUser.permissions.exportExcelCSV()) 
                        },
                    ], (e) => {
                        dxWorkbookToolbarComponent = e.component;
                    });
                },
            },
            {
                icon: 'dashboard',
                iconClass: 'mi',
                isDashboardWidgetsTab: true,
                title: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                    return this()?.name() ?? "Dashboard";
                }, workbook.workbookConfig.activeTab),
                visible: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                    let visible = this().tabType() === TabTypeEnum.Dashboard;
                    if (!visible) {
                        if (config.workbookHelper.activeToolbarTab() === 1) {
                            config.workbookHelper.activeToolbarTab(0);
                        }
                    }

                    return visible;
                }, workbook.workbookConfig.activeTab),
                templateClass: 'intro-dashboard-tab',
                template: () => {
                    let $div = $(`<widgets-toolbar params="config: $data"></widgets-toolbar>`);
                    ko.applyBindings(config, $div[0]);
                    return $div;
                }
            }, 
            {
                icon: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                    let activeTabOrWidget = this();
                    if (activeTabOrWidget.tabOrWidget === TabOrWidgetEnum.Widget || workbook.workbookConfig.activeTab().tabType() === TabTypeEnum.Dashboard) {
                        return "widgets";
                    }

                    return BaseWidget.getWidgetIcon(activeTabOrWidget.widgetType());
                }, workbook.workbookConfig.activeTabOrWidget),
                iconClass: 'ms',
                title: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                    let activeTabOrWidget = this();
                    if (activeTabOrWidget.tabOrWidget === TabOrWidgetEnum.Tab && workbook.workbookConfig.activeTab().tabType() === TabTypeEnum.Dashboard) {
                        return "Select a Widget";
                    }
                    return activeTabOrWidget.name();
                }, workbook.workbookConfig.activeTabOrWidget),
                templateClass: 'intro-report-tab',
                template: () => {
                    let $div = $(`<!-- ko if: !isChangingTabOrWidget() --><report-toolbar params="config: $data"></report-toolbar><!-- /ko -->`);
                    ko.applyBindings(config, $div[0]);
                    return $div;
                },
                isAnalyzeByTab: true,
            }, 
            {
                icon: 'tools_power_drill',
                iconClass: 'ms',
                title: 'Drilldown',
                template: () => {
                    let $div = $(`<drilldown-toolbar params="config: $data"></drilldown-toolbar>`);
                    ko.applyBindings(config, $div[0]);
                    return $div;
                },
                isDrilldownTab: true,
            }, 
            //{
            //    icon: 'dashboard',
            //    iconClass: 'mi',
            //    title: 'Dashboard',
            //    template: () => {
            //        return generateToolbar("tabworkbooktoolbar", [
            //            {
            //                location: 'before',
            //                widget: 'dxButton',
            //                options: {
            //                    hint: 'Rename',
            //                    template: `<i class="mi">drive_file_rename_outline</i> Rename`,
            //                    //stylingMode: 'contained',
            //                    //type: 'default',
            //                    onClick(e) {
            //                        config.activeTab().name(config.activeTab().name() + "X");
            //                        onButtonClick(e.component.option("hint"));
            //                    },
            //                },
            //            },
            //        ]);
            //    },
            //},
            {
                icon: 'filter_alt',
                iconClass: 'ms',
                title: 'Filters',
                visible: !isMobile(),
                templateClass: 'intro-filters-tab',
                template: () => {
                    let $div = $(`<filters params="config: $data.config, isToolbar: $data.isToolbar, element: $element"></filters>`);
                    ko.applyBindings({ config, isToolbar: true }, $div.get(0));
                    return $div;
                },
            }, 
        ];
    }
}